import { MessageCircle } from "lucide-react";
import { Reveal, Overline } from "@/components/Reveal";
import { useSettings } from "@/contexts/SettingsContext";

export const WhatsAppCTA = () => {
  const { waLink } = useSettings();

  return (
    <section id="pesan" className="bg-ink py-24 md:py-36 px-6 md:px-10">
      <div className="mx-auto max-w-4xl text-center">
        <Reveal>
          <Overline dark>Hubungi Kami</Overline>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl tracking-tight leading-[1.05] text-cream mb-6">
            Tertarik dengan madu kami?
          </h2>
          <p className="text-cream/75 leading-relaxed text-base md:text-lg mb-10 max-w-xl mx-auto">
            Chat langsung dengan kami di WhatsApp untuk tanya produk, cara
            pemesanan, atau kerja sama.
          </p>
          <a
            data-testid="whatsapp-cta-btn"
            href={waLink("Halo Samsi Madu, saya ingin bertanya tentang produk madu Anda.")}
            target="_blank"
            rel="noreferrer"
            className="group inline-flex items-center gap-3 rounded-full bg-wa px-8 py-4 text-base font-semibold text-white hover:bg-wa/90 transition-colors duration-300"
          >
            <MessageCircle size={22} />
            Hubungi via WhatsApp
            <span className="transition-transform duration-300 group-hover:translate-x-1">→</span>
          </a>
        </Reveal>
      </div>
    </section>
  );
};
